<template>
  <div v-if="errors" class="border-danger alert d-flex" role="alert">
    <p class="text-danger mb-0 my-auto">{{ errors.message }}</p>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import { httpStore } from "@/store/typed";

@Component
export default class DisplayErrors extends Vue {
  @Prop({ required: true }) readonly tag!: string;

  get errors() {
    return (
      httpStore.status[this.tag].statusCode === 422 &&
      httpStore.status[this.tag].errors
    );
  }
}
</script>
<style lang="scss" scoped>
.alert {
  height: 50px;
}
</style>
